function a() {
  return `${Math.floor(Math.random() * 1e10)}`.padStart(4, "0");
}
export {
  a as g
};
